import React, { useCallback, useState } from 'react';
import { isEmpty } from 'lodash';
import ExportDataForm from './ExportDataForm';
import {
  CSV,
  EXCEL,
  PDF,
  exportToPdfHandler,
  prepareForExport,
} from './support';
import { createNotification } from '../../../utils';
import { notificationType } from '../../../constants/globals';

const ExportDataFormContainer = (props) => {
  const { translations, gt, gridRef, submitRef, tableTitle } = props || {},
    { Errors, typeOfExportPlaceholder, NotificationMessages } =
      translations || {};

  const [typeOfExport, setTypeOfExport] = useState(EXCEL);
  const [errors, setErrors] = useState({});

  const onChangeComboBoxHandler = (value) => {
    setTypeOfExport(value);
  };

  const clientValidationHandler = () => {
    let errorsObject = {};

    if (!typeOfExport) {
      errorsObject['typeOfExport'] = Errors.typeOfExport;
    }

    setErrors(errorsObject);
    return !isEmpty(errorsObject);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (clientValidationHandler()) {
      return;
    }
    exportHandler();
  };

  const multipleExcelCSVExportHandler = useCallback(
    (signalForExcelExport, tableName) => {
      signalForExcelExport
        ? gridRef.current?.api?.exportDataAsExcel(
            prepareForExport(gridRef, gt, tableName)
          )
        : gridRef.current?.api?.exportDataAsCsv(
            prepareForExport(gridRef, gt, tableName)
          );
    },
    [gridRef, gt]
  );

  const exportCallback = () => {
    setTimeout(
      () =>
        createNotification(
          notificationType.success,
          NotificationMessages.exportTitle,
          NotificationMessages.successExport
        ),
      1000
    );
  };

  const exportHandler = () => {
    switch (typeOfExport) {
      case EXCEL:
        multipleExcelCSVExportHandler(true, tableTitle);
        exportCallback();
        break;
      case PDF:
        exportToPdfHandler(gridRef, tableTitle, gt);
        exportCallback();
        break;
      case CSV:
        multipleExcelCSVExportHandler(false, tableTitle);
        exportCallback();
        break;
      default:
        return;
    }
  };

  return (
    <ExportDataForm
      typeOfExportPlaceholder={typeOfExportPlaceholder}
      typeOfExport={typeOfExport}
      onChangeComboBoxHandler={onChangeComboBoxHandler}
      errors={errors}
      setErrors={setErrors}
      onSubmitHandler={onSubmitHandler}
      submitRef={submitRef}
    />
  );
};

export default ExportDataFormContainer;
